














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations, mapActions } from 'vuex';
import { get } from 'lodash';

import Unlocker from './Unlocker.vue';

import { PeriodicElement, BonusPeriodicElement } from '../data';

import lockupImg from '../assets/unlock-lockup.svg';

@Component({
  methods: { ...mapMutations(['setHovered', 'clearHovered']) },
  components: { Unlocker },
})
export default class Element extends Vue {
  @Prop()
  private element: PeriodicElement | BonusPeriodicElement = this.element;
  @Prop() private selected: boolean = this.selected;

  private setHovered: (element?: string) => void = this.setHovered;

  get elementStyle() {
    return {
      gridColumn: this.element.column,
      gridRow: this.element.row,
    };
  }

  get lockupImg() {
    return lockupImg;
  }

  get unlockProgress() {
    return get(this.element, 'unlockProgress', 1);
  }

  get unlockStyle() {
    const progressPercentage = (1 - this.unlockProgress) * 100;
    return {
      width: `${progressPercentage}%`,
    };
  }

  get unlockImgStyle() {
    const progressPercentage = 1 / this.unlockProgress * 100;
    return {
      left: `-${progressPercentage / 2}%`,
    };
  }

  get prereqElements() {
    const element = this.element as BonusPeriodicElement;
    const prereqs = element.prereqElements;
    return prereqs.join('+');
  }

  private handleHover() {
    this.setHovered(this.element.element);
  }

  private handleLeave() {
    this.setHovered();
  }

  private handleToggle() {
    if (this.unlockProgress === 1) {
      this.$router.push(`/${this.element.element}`);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Element.vue